import api from './api';

const customerJourneyNodeService = {
  // 获取节点关联的SOP信息
  getNodeSopInfo: async (nodeId) => {
    return api.get(`/customer-journey-nodes/${nodeId}/sop-info`);
  }
};

export default customerJourneyNodeService;